import React from 'react';
import AdmissionForm from './forms/AdmissionForm';
import ConcessionForm from './forms/ConcessionForm';

const FormManagement = ({
    admissionFormSaveHandler,
    activeApplicationDetails
}) => {
    return (
        <div className='mb-2'>
            <h3 className='mb-3' style={{ fontSize: '20px' }}>
                Form Management
            </h3>

            <AdmissionForm
                admissionFormSaveHandler={admissionFormSaveHandler}
                activeApplicationDetails={activeApplicationDetails}
            />

            <ConcessionForm
                activeApplicationDetails={activeApplicationDetails}
            />
        </div>
    );
}

export default FormManagement;